import { useEffect, useRef } from 'react';


/**
 * Reveal-ul logo-ului din header: o "trecere de lumină" verticală, o singură dată
 * pe sesiune. Subtil, fără să întârzie LCP (rulează după mount).
 */
export function useGsapLogoReveal<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Dacă hidratarea a durat mult, logo-ul e deja vizibil de ceva vreme —
    // nu-l mai animăm, ar părea o „săritură" fără motiv.
    if (typeof performance !== 'undefined' && performance.now() > 2500) return;
    try {
      if (sessionStorage.getItem('ram_logo_revealed') === '1') return;
      sessionStorage.setItem('ram_logo_revealed', '1');
    } catch {
      /* storage indisponibil — animăm oricum */
    }

    // GSAP e importat dinamic ca să nu intre în bundle-ul principal (LCP/TBT).
    let cancelled = false;
    let cleanup: (() => void) | undefined;

    (async () => {
      const { gsap } = await import('@/lib/gsap');
      if (cancelled || !ref.current) return;
      const ctx = gsap.context(() => {
        gsap.fromTo(
          ref.current,
          { opacity: 0, y: -8, scale: 0.94 },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.7,
            ease: 'power3.out',
            clearProps: 'all',
          }
        );
      }, ref.current);
      cleanup = () => ctx.revert();
    })();

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);


  return ref;
}
